import { graphql } from "react-relay";
import { FastCrawlErrorCard } from "@components/fast-crawl-error-card";
import "@components/web-app-nav/web-app-nav-avatar-menu/WebAppNavAvatarMenu.gql";
import "@components/onboarding-common/onboarding-chrome-intro/OnboardingChromeIntro.gql";
import "./onboarding-steps/onboarding-survey-step/OnboardingSurveyStep.gql";
import "./onboarding-steps/onboarding-team-join-create-step/OnboardingTeamJoinCreateStep.gql";
import "./onboarding-steps/onboarding-working-hours-step/OnboardingWorkingHoursStep.gql";
import "./onboarding-steps/onboarding-meeting-hours-step/OnboardingMeetingHoursStep.gql";
import "./onboarding-steps/onboarding-lunch-step/OnboardingLunchStep.gql";
import "./onboarding-steps/onboarding-focus-time-sync-and-lunch-step/OnboardingFocusTimeSyncAndLunchStep.gql";
import "./onboarding-steps/onboarding-introduce-focus-time-step/OnboardingIntroduceFocusTimeStep.gql";
import "./onboarding-steps/onboarding-introduce-autopilot-step/OnboardingIntroduceAutopilotStep.gql";
import "./onboarding-steps/onboarding-autopilot-step/OnboardingAutopilotStepRenderer.gql";
import "./onboarding-steps/onboarding-focus-time-sync-step/OnboardingFocusTimeSyncStep.gql";
import "./onboarding-steps/onboarding-invite-step/OnboardingInviteStep.gql";
import "./onboarding-steps/onboarding-color-coding-step/OnboardingColorCodingStep.gql";
import "./onboarding-steps/onboarding-private-calendar-sync-step/OnboardingPrivateCalendarSyncStep.gql";
import "./onboarding-steps/onboarding-travel-time-step/OnboardingTravelTimeStep.gql";
import "./onboarding-steps/onboarding-slack-step/OnboardingSlackStep.gql";
import "./onboarding-steps/onboarding-summary-step/OnboardingSummaryStep.gql";
import "./onboarding-steps/onboarding-jtbd-survey-step/IndividualJtbdSurveyStep.gql";
import "./onboarding-steps/onboarding-links-step/OnboardingLinksStep.gql";
import "./onboarding-steps/onboarding-schedule-test-event-step/OnboardingScheduleTestEventStepRenderer.gql";
import "./onboarding-steps/onboarding-flex-meeting-step/OnboardingFlexMeetingStepRenderer.gql";

export const fragments = {
  viewer: graphql`
    fragment OnboardingNUX_viewer on Viewer
    @argumentDefinitions(
      orgRelayId: { type: "ID!" }
      myCalendarIds: { type: "[String!]!" }
      timeZone: { type: "String!" }
      week: { type: "LocalWeek!" }
    ) {
      ...WebAppNavAvatarMenu_viewer
      ...OnboardingInviteStep_viewer
      ...OnboardingTeamJoinCreateStep_viewer
        @arguments(orgRelayId: $orgRelayId, myCalendarIds: $myCalendarIds)
      outerTeamQueryResultErrorable: teamQueryResultErrorable(
        query: ""
        orgRelayId: $orgRelayId
        excludeMyTeams: false
      ) {
        ... on TeamQueryResult {
          query
          teams {
            teamId
          }
        }
      }
      user {
        ...OnboardingChromeIntro_user
        ...OnboardingFocusTimeSyncAndLunchStep_user
        ...OnboardingIntroduceFocusTimeStep_user
        ...OnboardingScheduleTestEventStepRenderer_user
        ...OnboardingAutopilotStepRenderer_user
        ...OnboardingColorCodingStep_user
        ...OnboardingPrivateCalendarSyncStep_user
        ...OnboardingSummaryStep_user
        ...OnboardingFlexMeetingStepRenderer_user
        createdTime
        dataSources(first: 1000000) {
          edges {
            node {
              id
              state
              type
              name
            }
          }
        }
        flowStates(first: 1000000) {
          edges {
            node {
              id
              flowKey
              current {
                id
                state
                percentComplete
                errorMessage
              }
              pending {
                state
                percentComplete
                errorMessage
              }
            }
          }
        }
        orgs(first: 1000000) {
          edges {
            node {
              ...FastCrawlErrorCard_org
              ...OnboardingChromeIntro_org
              ...OnboardingSurveyStep_org
              ...IndividualJtbdSurveyStep_org
              ...OnboardingTeamJoinCreateStep_org
              ...OnboardingWorkingHoursStep_org
              ...OnboardingMeetingHoursStep_org
              ...OnboardingLunchStep_org
              ...OnboardingFocusTimeSyncAndLunchStep_org
              ...OnboardingIntroduceAutopilotStep_org
              ...OnboardingLinksStep_org
              ...OnboardingFocusTimeSyncStep_org
              ...OnboardingPrivateCalendarSyncStep_org
              ...OnboardingTravelTimeStep_org
              ...OnboardingSlackStep_org
              ...OnboardingSummaryStep_org
              ...OnboardingIntroduceFocusTimeStep_org @arguments(week: $week)
              ...OnboardingAutopilotStepRenderer_org @arguments(timeZone: $timeZone)
              ...OnboardingInviteStep_org
              ...OnboardingColorCodingStep_org @arguments(week: $week)
              ...OnboardingScheduleTestEventStepRenderer_org @arguments(week: $week)
              ...OnboardingFlexMeetingStepRenderer_org @arguments(timeZone: $timeZone)
              id
              primaryOrgCalendar
              experiments
              crawlTest

              userTeams {
                __typename
                ... on TeamList {
                  list {
                    teamId
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
};
